// MBTI Questions with cultural relevance for South Asian context
export const questions = [
  {
    id: 1,
    category: 'EI', // Extraversion vs Introversion
    en: {
      question: 'At a family gathering (mehfil), you would:',
      options: [
        'Enjoy meeting and chatting with extended family members',
        'Prefer staying with close family members you already know',
        'Find a quiet corner to observe and listen to conversations',
        'Help with serving food and organizing things'
      ]
    },
    ur: {
      question: 'خاندانی محفل میں آپ:',
      options: [
        'رشتہ داروں سے ملنا اور بات چیت کرنا پسند کریں گے',
        'ان لوگوں کے ساتھ رہنا پسند کریں گے جنہیں آپ پہلے سے جانتے ہیں',
        'کوئی پرسکون جگہ ڈھونڈ کر گفتگو سننا پسند کریں گے',
        'کھانا پیش کرنے اور چیزوں کو منظم کرنے میں مدد کریں گے'
      ]
    },
    weights: [2, 1, -1, 0] // E, E, I, I
  },
  {
    id: 2,
    category: 'SN', // Sensing vs Intuition
    en: {
      question: 'When planning a trip to the northern areas, you would:',
      options: [
        'Research detailed itineraries, weather, and exact locations',
        'Focus on the overall experience and what emotions you want to feel',
        'Ask friends who have been there for practical advice',
        'Keep it flexible and see where the journey takes you'
      ]
    },
    ur: {
      question: 'شمالی علاقوں کا سفر منصوبہ بناتے وقت آپ:',
      options: [
        'تفصیلی منصوبے، موسم اور صحیح جگہوں کی تحقیق کریں گے',
        'مجموعی تجربے اور جذبات پر توجہ دیں گے',
        'وہاں گئے دوستوں سے عملی مشورہ لیں گے',
        'لچکدار رکھیں گے اور دیکھیں گے کہ سفر کہاں لے جاتا ہے'
      ]
    },
    weights: [2, -1, 1, -2] // S, N, S, N
  },
  {
    id: 3,
    category: 'TF', // Thinking vs Feeling
    en: {
      question: 'When a friend asks for money during a difficult time, you would:',
      options: [
        'Analyze their situation logically and consider the risks',
        'Feel their pain and want to help immediately',
        'Ask questions to understand the full situation first',
        'Help them find alternative solutions instead of just giving money'
      ]
    },
    ur: {
      question: 'جب کوئی دوست مشکل وقت میں پیسے مانگے تو آپ:',
      options: [
        'ان کی صورت حال کا منطقی تجزیہ کریں گے اور خطرات پر غور کریں گے',
        'ان کے درد کو محسوس کریں گے اور فوراً مدد کرنا چاہیں گے',
        'پہلے مکمل صورت حال سمجھنے کے لیے سوالات پوچھیں گے',
        'صرف پیسے دینے کے بجائے متبادل حل تلاش کرنے میں مدد کریں گے'
      ]
    },
    weights: [2, -2, 1, 0] // T, F, T, F
  },
  {
    id: 4,
    category: 'JP', // Judging vs Perceiving
    en: {
      question: 'During exam preparation, you would:',
      options: [
        'Create a detailed study schedule and stick to it religiously',
        'Study when you feel motivated and take breaks when needed',
        'Focus on understanding concepts rather than following a strict timeline',
        'Join study groups but keep your approach flexible'
      ]
    },
    ur: {
      question: 'امتحان کی تیاری کے دوران آپ:',
      options: [
        'تفصیلی مطالعے کا شیڈول بنائیں گے اور سختی سے اس پر عمل کریں گے',
        'جب جذبہ ہو تو مطالعہ کریں گے اور ضرورت پڑنے پر وقفہ لیں گے',
        'سخت وقت بندی کے بجائے تصورات کو سمجھنے پر توجہ دیں گے',
        'مطالعے کے گروپس میں شامل ہوں گے لیکن اپنا طریقہ لچکدار رکھیں گے'
      ]
    },
    weights: [2, -1, 0, -2] // J, P, J, P
  },
  {
    id: 5,
    category: 'EI',
    en: {
      question: 'In a WhatsApp group chat, you would:',
      options: [
        'Actively participate in conversations and share updates',
        'Respond to messages when directly asked something',
        'Mostly read messages without commenting much',
        'Only respond to important or urgent messages'
      ]
    },
    ur: {
      question: 'واٹس ایپ گروپ چیٹ میں آپ:',
      options: [
        'گفتگو میں فعال طور پر حصہ لیں گے اور اپڈیٹس شیئر کریں گے',
        'جب براہ راست کچھ پوچھا جائے تو جواب دیں گے',
        'زیادہ تبصرے کیے بغیر پیغامات پڑھتے رہیں گے',
        'صرف اہم یا فوری پیغامات کا جواب دیں گے'
      ]
    },
    weights: [2, 1, -1, -2] // E, E, I, I
  },
  {
    id: 6,
    category: 'SN',
    en: {
      question: 'When someone describes their dream, you would:',
      options: [
        'Focus on the practical meaning and what they should do about it',
        'Ask about the emotions and symbols in the dream',
        'Try to interpret it based on common dream meanings',
        'Be interested in what it reveals about their subconscious mind'
      ]
    },
    ur: {
      question: 'جب کوئی اپنے خواب کا بیان کرے تو آپ:',
      options: [
        'عملی معنی اور اس کے بارے میں کیا کرنا چاہیے پر توجہ دیں گے',
        'خواب میں جذبات اور علامتوں کے بارے میں پوچھیں گے',
        'عام خوابوں کے معنی کی بنیاد پر اس کی تشریح کرنے کی کوشش کریں گے',
        'یہ جاننے میں دلچسپی ہوگی کہ یہ ان کے لاشعور کے بارے میں کیا ظاہر کرتا ہے'
      ]
    },
    weights: [2, -1, 1, -2] // S, N, S, N
  },
  {
    id: 7,
    category: 'TF',
    en: {
      question: 'When making a career decision, you would:',
      options: [
        'Analyze salary, benefits, and growth opportunities',
        'Consider how the job aligns with your values and passions',
        'Research the company culture and work environment',
        'Think about the impact this job will have on your family'
      ]
    },
    ur: {
      question: 'کیرئیر کا فیصلہ کرتے وقت آپ:',
      options: [
        'تنخواہ، فوائد اور ترقی کے مواقع کا تجزیہ کریں گے',
        'اس بات پر غور کریں گے کہ نوکری آپ کی اقدار اور جذبات سے کیسے میل کھاتی ہے',
        'کمپنی کی ثقافت اور کام کے ماحول کی تحقیق کریں گے',
        'اس بات پر سوچیں گے کہ یہ نوکری آپ کے خاندان پر کیا اثر ڈالے گی'
      ]
    },
    weights: [2, -2, 1, -1] // T, F, T, F
  },
  {
    id: 8,
    category: 'JP',
    en: {
      question: 'When organizing a wedding ceremony, you would:',
      options: [
        'Create detailed checklists and timelines for everything',
        'Focus on the overall atmosphere and guest experience',
        'Handle things as they come up and adapt to changes',
        'Delegate tasks to family members and trust their judgment'
      ]
    },
    ur: {
      question: 'شادی کی تقریب منظم کرتے وقت آپ:',
      options: [
        'ہر چیز کے لیے تفصیلی چیک لسٹ اور وقت کا جدول بنائیں گے',
        'مجموعی ماحول اور مہمانوں کے تجربے پر توجہ دیں گے',
        'جیسے جیسے کام آئیں ویسے ہی سنبھالیں گے اور تبدیلیوں کے مطابق ڈھلیں گے',
        'خاندان کے ارکان کو کام سونپیں گے اور ان کے فیصلے پر بھروسہ کریں گے'
      ]
    },
    weights: [2, 1, -2, -1] // J, J, P, P
  },
  {
    id: 9,
    category: 'EI',
    en: {
      question: 'During load shedding (power outage), you would:',
      options: [
        'Go outside and spend time with neighbors',
        'Stay home and enjoy the quiet time with family',
        'Find ways to entertain yourself independently',
        'Use it as an opportunity to catch up on reading'
      ]
    },
    ur: {
      question: 'لوڈ شیڈنگ کے دوران آپ:',
      options: [
        'باہر جائیں گے اور پڑوسیوں کے ساتھ وقت گزاریں گے',
        'گھر میں رہیں گے اور خاندان کے ساتھ پرسکون وقت گزاریں گے',
        'خود کو آزادانہ طور پر تفریح فراہم کرنے کے طریقے تلاش کریں گے',
        'اسے پڑھائی میں اضافہ کے موقع کے طور پر استعمال کریں گے'
      ]
    },
    weights: [2, 1, -1, -2] // E, E, I, I
  },
  {
    id: 10,
    category: 'SN',
    en: {
      question: 'When someone tells you about their problems, you would:',
      options: [
        'Focus on practical solutions and next steps',
        'Try to understand the deeper meaning and patterns',
        'Ask for specific details about what happened',
        'Look for underlying causes and connections'
      ]
    },
    ur: {
      question: 'جب کوئی اپنے مسائل کے بارے میں بتائے تو آپ:',
      options: [
        'عملی حل اور اگلے اقدامات پر توجہ دیں گے',
        'گہرے معنی اور نمونوں کو سمجھنے کی کوشش کریں گے',
        'ہونے والے واقعات کی تفصیلات پوچھیں گے',
        'بنیادی وجوہات اور روابط تلاش کریں گے'
      ]
    },
    weights: [2, -2, 1, -1] // S, N, S, N
  }
];

// Personality types with descriptions
export const personalityTypes = {
  INTJ: {
    en: {
      name: 'The Architect',
      description: 'Imaginative and strategic thinkers, with a plan for everything.',
      traits: ['Strategic', 'Independent', 'Determined', 'Curious'],
      strengths: ['Long-term planning', 'Critical thinking', 'Self-confidence'],
      famous: ['Elon Musk', 'Stephen Hawking', 'Nikola Tesla']
    },
    ur: {
      name: 'معمار',
      description: 'تخیلاتی اور حکمت عملی کے سوچ والے، ہر چیز کے لیے منصوبہ رکھتے ہیں۔',
      traits: ['حکمت عملی', 'آزاد', 'پرعزم', 'تجسس'],
      strengths: ['طویل مدتی منصوبہ بندی', 'تنقیدی سوچ', 'خود اعتمادی'],
      famous: ['ایلون مسک', 'سٹیفن ہاکنگ', 'نکولا ٹیسلا']
    },
    color: '#6366f1'
  },
  INTP: {
    en: {
      name: 'The Thinker',
      description: 'Innovative inventors with an unquenchable thirst for knowledge.',
      traits: ['Analytical', 'Original', 'Absent-minded', 'Objective'],
      strengths: ['Problem-solving', 'Theoretical thinking', 'Flexibility'],
      famous: ['Albert Einstein', 'Charles Darwin', 'Marie Curie']
    },
    ur: {
      name: 'فکر کرنے والا',
      description: 'جدت پسند موجد جو علم کی پیاس کے لیے مشہور ہیں۔',
      traits: ['تحلیلی', 'اصل', 'غائب دماغ', 'معروضی'],
      strengths: ['مسئلہ حل کرنا', 'نظریاتی سوچ', 'لچک'],
      famous: ['البرٹ آئن سٹائن', 'چارلس ڈارون', 'میری کیوری']
    },
    color: '#8b5cf6'
  },
  ENTJ: {
    en: {
      name: 'The Commander',
      description: 'Bold, imaginative leaders, always finding a way forward.',
      traits: ['Bold', 'Rational', 'Assertive', 'Strong-willed'],
      strengths: ['Leadership', 'Confidence', 'Strategic planning'],
      famous: ['Napoleon Bonaparte', 'Steve Jobs', 'Margaret Thatcher']
    },
    ur: {
      name: 'کمانڈر',
      description: 'جرات مند، تخیلاتی لیڈر، ہمیشہ آگے بڑھنے کا راستہ تلاش کرتے ہیں۔',
      traits: ['جرات مند', 'منطقی', 'پراعتماد', 'مضبوط ارادے والا'],
      strengths: ['قیادت', 'اعتماد', 'حکمت عملی کی منصوبہ بندی'],
      famous: ['نیپولین بوناپارٹ', 'اسٹیو جابز', 'مارگریٹ تھیچر']
    },
    color: '#dc2626'
  },
  ENTP: {
    en: {
      name: 'The Debater',
      description: 'Smart and curious thinkers who cannot resist an intellectual challenge.',
      traits: ['Smart', 'Curious', 'Enthusiastic', 'Good-natured'],
      strengths: ['Creativity', 'Communication', 'Adaptability'],
      famous: ['Mark Twain', 'Thomas Edison', 'Richard Feynman']
    },
    ur: {
      name: 'بحث کرنے والا',
      description: 'ذہین اور تجسس سے بھرپور سوچ والے جو ذہنی چیلنج کو رد نہیں کر سکتے۔',
      traits: ['ذہین', 'تجسس', 'پرجوش', 'اچھے مزاج والا'],
      strengths: ['تخلیقیت', 'مواصلات', 'موافقت'],
      famous: ['مارک ٹوین', 'تھامس ایڈیسن', 'رچرڈ فائن مین']
    },
    color: '#f59e0b'
  },
  INFJ: {
    en: {
      name: 'The Advocate',
      description: 'Creative and insightful, inspired by idealism and purpose.',
      traits: ['Creative', 'Insightful', 'Principled', 'Passionate'],
      strengths: ['Empathy', 'Intuition', 'Determination'],
      famous: ['Mother Teresa', 'Nelson Mandela', 'Martin Luther King Jr.']
    },
    ur: {
      name: 'وکیل',
      description: 'تخلیقی اور بصیرت والا، مثالیات اور مقصد سے متاثر۔',
      traits: ['تخلیقی', 'بصیرت والا', 'اصولی', 'جذباتی'],
      strengths: ['ہمدردی', 'الہام', 'عزم'],
      famous: ['مدر ٹریسا', 'نیلسن منڈیلا', 'مارٹن لوتھر کنگ جونیئر']
    },
    color: '#059669'
  },
  INFP: {
    en: {
      name: 'The Mediator',
      description: 'Poetic, kind and altruistic people, always eager to help a good cause.',
      traits: ['Idealistic', 'Curious', 'Loyal', 'Flexible'],
      strengths: ['Empathy', 'Creativity', 'Open-mindedness'],
      famous: ['William Shakespeare', 'J.R.R. Tolkien', 'Princess Diana']
    },
    ur: {
      name: 'ثالث',
      description: 'شاعرانہ، مہربان اور دوسروں کی بھلائی کرنے والے لوگ، ہمیشہ اچھے مقصد میں مدد کے لیے تیار۔',
      traits: ['مثالی', 'تجسس', 'وفادار', 'لچکدار'],
      strengths: ['ہمدردی', 'تخلیقیت', 'کھلے ذہن والا'],
      famous: ['ولیم شیکسپیئر', 'جے آر آر ٹولکین', 'پرنسز ڈیانا']
    },
    color: '#ec4899'
  },
  ENFJ: {
    en: {
      name: 'The Protagonist',
      description: 'Charismatic and inspiring leaders, able to mesmerize their listeners.',
      traits: ['Charismatic', 'Inspiring', 'Altruistic', 'Natural-born leaders'],
      strengths: ['Leadership', 'Communication', 'Empathy'],
      famous: ['Oprah Winfrey', 'Barack Obama', 'Maya Angelou']
    },
    ur: {
      name: 'مرکزی کردار',
      description: 'کرشماتی اور متاثر کن لیڈر، اپنے سامعین کو متاثر کرنے کی صلاحیت رکھتے ہیں۔',
      traits: ['کرشماتی', 'متاثر کن', 'دوسروں کی بھلائی کرنے والا', 'فطری لیڈر'],
      strengths: ['قیادت', 'مواصلات', 'ہمدردی'],
      famous: ['اوپرا ونفرے', 'بارک اوباما', 'مایا اینجلو']
    },
    color: '#10b981'
  },
  ENFP: {
    en: {
      name: 'The Campaigner',
      description: 'Enthusiastic, creative and sociable free spirits, always finding a reason to smile.',
      traits: ['Enthusiastic', 'Creative', 'Sociable', 'Free-spirited'],
      strengths: ['Creativity', 'Communication', 'Optimism'],
      famous: ['Robin Williams', 'Will Smith', 'Ellen DeGeneres']
    },
    ur: {
      name: 'جہم',
      description: 'پرجوش، تخلیقی اور ملنسار آزاد روح، ہمیشہ مسکرانے کی وجہ تلاش کرتے ہیں۔',
      traits: ['پرجوش', 'تخلیقی', 'ملنسار', 'آزاد روح'],
      strengths: ['تخلیقیت', 'مواصلات', 'امید واری'],
      famous: ['روبین ولیمز', 'ول سمتھ', 'ایلن ڈی جنرس']
    },
    color: '#f97316'
  },
  ISTJ: {
    en: {
      name: 'The Inspector',
      description: 'Practical and fact-minded, reliable and responsible.',
      traits: ['Honest', 'Direct', 'Strong-willed', 'Dutiful'],
      strengths: ['Reliability', 'Patience', 'Detail-oriented'],
      famous: ['George Washington', 'Warren Buffett', 'Angela Merkel']
    },
    ur: {
      name: 'محتسب',
      description: 'عملی اور حقیقت پسند، قابل اعتماد اور ذمہ دار۔',
      traits: ['ایماندار', 'سیدھا', 'مضبوط ارادے والا', 'فرض شناس'],
      strengths: ['قابل اعتماد', 'صبر', 'تفصیل پر توجہ'],
      famous: ['جارج واشنگٹن', 'وارن بفیٹ', 'انجیلا مرکل']
    },
    color: '#6b7280'
  },
  ISFJ: {
    en: {
      name: 'The Protector',
      description: 'Very dedicated and warm protectors, always ready to defend their loved ones.',
      traits: ['Supportive', 'Reliable', 'Patient', 'Imaginative'],
      strengths: ['Loyalty', 'Patience', 'Empathy'],
      famous: ['Mother Teresa', 'Kate Middleton', 'Jimmy Carter']
    },
    ur: {
      name: 'محافظ',
      description: 'بہت مخلص اور گرم محافظ، ہمیشہ اپنے پیاروں کی حفاظت کے لیے تیار۔',
      traits: ['مددگار', 'قابل اعتماد', 'صبر کرنے والا', 'تخیلاتی'],
      strengths: ['وفاداری', 'صبر', 'ہمدردی'],
      famous: ['مدر ٹریسا', 'کیٹ مڈلٹن', 'جمی کارٹر']
    },
    color: '#84cc16'
  },
  ESTJ: {
    en: {
      name: 'The Executive',
      description: 'Excellent administrators, unsurpassed at managing things or people.',
      traits: ['Dedicated', 'Strong-willed', 'Direct', 'Honest'],
      strengths: ['Organization', 'Leadership', 'Practicality'],
      famous: ['Henry Ford', 'Judge Judy', 'Kamala Harris']
    },
    ur: {
      name: 'ایگزیکٹو',
      description: 'بہترین منتظم، چیزوں یا لوگوں کو منظم کرنے میں بے مثال۔',
      traits: ['مخلص', 'مضبوط ارادے والا', 'سیدھا', 'ایماندار'],
      strengths: ['تنظیم', 'قیادت', 'عملیت'],
      famous: ['ہنری فورڈ', 'جج جڈی', 'کمالا ہیرس']
    },
    color: '#ef4444'
  },
  ESFJ: {
    en: {
      name: 'The Consul',
      description: 'Extraordinarily caring, social and popular people, always eager to help.',
      traits: ['Strong', 'Practical', 'Loyal', 'Sensitive'],
      strengths: ['Caring', 'Social skills', 'Reliability'],
      famous: ['Taylor Swift', 'Bill Clinton', 'Sally Field']
    },
    ur: {
      name: 'قونصل',
      description: 'غیر معمولی ہمدرد، سماجی اور مقبول لوگ، ہمیشہ مدد کے لیے تیار۔',
      traits: ['مضبوط', 'عملی', 'وفادار', 'حساس'],
      strengths: ['ہمدردی', 'سماجی مہارت', 'قابل اعتماد'],
      famous: ['ٹیلر سوفٹ', 'بل کلنٹن', 'سالی فیلڈ']
    },
    color: '#f43f5e'
  },
  ISTP: {
    en: {
      name: 'The Virtuoso',
      description: 'Bold and practical experimenters, masters of all kinds of tools.',
      traits: ['Optimistic', 'Creative', 'Practical', 'Spontaneous'],
      strengths: ['Practical skills', 'Adaptability', 'Problem-solving'],
      famous: ['Tom Cruise', 'Clint Eastwood', 'Zendaya']
    },
    ur: {
      name: 'ماہر',
      description: 'جرات مند اور عملی تجربہ کار، ہر قسم کے آلات کے ماہر۔',
      traits: ['امید وار', 'تخلیقی', 'عملی', 'بے ساختہ'],
      strengths: ['عملی مہارت', 'موافقت', 'مسئلہ حل کرنا'],
      famous: ['ٹام کروز', 'کلنٹ ایسٹ وڈ', 'زنڈایا']
    },
    color: '#8b5cf6'
  },
  ISFP: {
    en: {
      name: 'The Adventurer',
      description: 'Flexible and charming artists, always ready to explore new possibilities.',
      traits: ['Charming', 'Sensitive', 'Artistic', 'Flexible'],
      strengths: ['Creativity', 'Empathy', 'Adaptability'],
      famous: ['Michael Jackson', 'Brad Pitt', 'Frida Kahlo']
    },
    ur: {
      name: 'مہم جو',
      description: 'لچکدار اور دلکش فنکار، ہمیشہ نئے امکانات تلاش کرنے کے لیے تیار۔',
      traits: ['دلکش', 'حساس', 'فنکارانہ', 'لچکدار'],
      strengths: ['تخلیقیت', 'ہمدردی', 'موافقت'],
      famous: ['مائیکل جیکسن', 'بریڈ پٹ', 'فریدا کالو']
    },
    color: '#06b6d4'
  },
  ESTP: {
    en: {
      name: 'The Entrepreneur',
      description: 'Smart, energetic and very perceptive people, truly enjoy living on the edge.',
      traits: ['Bold', 'Practical', 'Original', 'Perceptive'],
      strengths: ['Adaptability', 'Practicality', 'Social skills'],
      famous: ['Donald Trump', 'Ernest Hemingway', 'Bruce Willis']
    },
    ur: {
      name: 'کاروباری',
      description: 'ذہین، توانا اور بہت بصیرت والے لوگ، واقعی کنارے پر رہنا پسند کرتے ہیں۔',
      traits: ['جرات مند', 'عملی', 'اصل', 'بصیرت والا'],
      strengths: ['موافقت', 'عملیت', 'سماجی مہارت'],
      famous: ['ڈونلڈ ٹرمپ', 'ارنسٹ ہیمنگوے', 'بروس ولیس']
    },
    color: '#eab308'
  },
  ESFP: {
    en: {
      name: 'The Entertainer',
      description: 'Spontaneous, energetic and enthusiastic people - life is never boring around them.',
      traits: ['Bold', 'Original', 'Aesthetics', 'Showmanship'],
      strengths: ['Social skills', 'Optimism', 'Creativity'],
      famous: ['Marilyn Monroe', 'Elvis Presley', 'Jamie Foxx']
    },
    ur: {
      name: 'تفریح فراہم کرنے والا',
      description: 'بے ساختہ، توانا اور پرجوش لوگ - ان کے ارد گرد زندگی کبھی بور نہیں ہوتی۔',
      traits: ['جرات مند', 'اصل', 'جمالیات', 'نمائش پسند'],
      strengths: ['سماجی مہارت', 'امید واری', 'تخلیقیت'],
      famous: ['میری لین منرو', 'ایلوس پریسلی', 'جیمی فوکس']
    },
    color: '#f97316'
  }
};
